
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Previewer from 'vux/src/components/previewer/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Badge from 'vux/src/components/badge/index.vue'

import banner from '@/assets/mail-banner.png'
import imgup from '@/assets/upload_img.png'
import icoLY from '@/assets/ico-ly.png'
import icoDel from '@/assets/ico-del.png'
import { getLawMyask } from '@/api/lawyer'
import Storage from '@/storage'
import store from '@/store'
import Scroll from '@/components/scroller'
import config from '@/config/index'
import { myDeal } from '@/api/youzheng.js'
export default {
name: 'myLawask',
data () {
return {
tablist: [
{
id: 1,
title: '未解答'
},
{
id: 2,
title: '已解答'
}
],
baseUrl: config.baseUrl,
select: 0,
icoLY: icoLY,
icoDel: icoDel,
notFirstLoad: false,
loadMoreDom: null,
listDom: null,
declareList: [],
page: 1,
rows: 10,
askstatus: 1,
imglist: [],
options: {
getThumbBoundsFn (index) {

let thumbnail = document.querySelectorAll('.previewer-demo-img')[
index
]
let pageYScroll =
window.pageYOffset || document.documentElement.scrollTop
let rect = thumbnail.getBoundingClientRect()
return { x: rect.left, y: rect.top + pageYScroll, w: rect.width }
}
},
lawyerNum: 0
}
},
components: {
Popup,
Group,
XButton,
Tabbar,
TabbarItem,
Tab,
TabItem,
Flexbox,
FlexboxItem,
Scroll,
Previewer,
Badge
},
directives: {
TransferDom
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}
},
watch: {
askstatus: function (nval, onav) {
this.refresh()
}
},
mounted () {
this.loadMoreDom = this.$el.querySelector('.load-more')
this.listDom = this.$el.querySelector('.list-scroll')
this.getmydeal()
},
methods: {
getmydeal () {
myDeal({
accountid: this.accountid,
idtype: 2,
userid: this.userid
}).then(res => {
this.lawyerNum = res.obj.lawyerNum
})
},
getlist (type, done) {
getLawMyask({
accountid: this.accountid,
statusid: this.askstatus,
idtype: 2,
page: this.page,
rows: this.rows
}).then(res => {
if (type === 'refresh') {
this.declareList = []
this.listDom.scrollTop = 0
}
if (res.returnValue.rows !== '' && res.returnValue.rows.length > 0) {
res.returnValue.rows.forEach(item => {
this.declareList.push({
createdate: item.createdate,
description: item.description.replace(/\n|\r\n/g, '<br/>'),
id: item.id,
advicetypeNAME: item.advicetypeNAME,
askername: item.askername,
lawyerid: item.lawyerid,
lawyername: item.lawyername,
askpicsList: item.askpicsList,
answerpicsList: item.answerpicsList,
answer: item.answer.replace(/\n|\r\n/g, '<br/>'),
lawyerPicPath: item.lawyerPicPath,
answershow: false,
updatedate: item.updatedate
})
})
}
this.declareList.forEach(item => {
let date1 = new Date().getTime() 
let date2 = new Date(item.createdate.replace(/-/g, '/')).getTime() 
let date3 = new Date(item.updatedate.replace(/-/g, '/')).getTime() 
let date4 = date1 - date2 
let date5 = date1 - date3 
let days1 = Math.floor(date4 / (24 * 3600 * 1000))
let days2 = Math.floor(date5 / (24 * 3600 * 1000))
if (days1 < 1) {
item.createdate = item.createdate.slice(11)
}
if (days2 < 1) {
item.updatedate = item.updatedate.slice(11)
}
})

if (res.returnValue.total === 0) {
this.notFirstLoad = true
} else {
this.notFirstLoad = false
}
if (
res.returnValue.rows.length === 0 ||
res.returnValue.total < this.rows
) {
this.loadMoreDom.innerText = '我也是有底线的～o～'
setTimeout(() => {
this.loadMoreDom.style.display = 'none'
}, 2000)
}
done && done()
if (this.select === 1) {
this.getmydeal()
}
})
},
showpre (index, list) {
this.imglist = []
list.forEach(res => {
this.imglist.push({
msrc: this.baseUrl + res.FILEPATH,
src: this.baseUrl + res.FILEPATH
})
})
setTimeout(() => {
this.$refs.previewer.show(index)
}, 300)

},
gopath () {
this.$router.push({ name: 'lawyerIndex' })
},
onItemClick (index) {
this.declareList = []
this.select = index
this.askstatus = index + 1
},
reply (id) {
this.$router.push({ name: 'myReply', params: { id: id } })
},
godetail (id) {
this.$router.push({ name: 'myMailDetailCommon', params: { id: id } })
},

refresh (done) {
this.page = 1
this.loadMoreDom.innerText = '加载中...'
this.getlist('refresh', done)
},

loadMore (done) {
this.page++
this.getlist('more', done)
}
},
activated () {},
created () {
this.getlist()
}
}
